export const SIGN_UP = '/auth/signup';
export const GRAPHQL = '/graphql';
export const GET_PAID_BILLS = '/bill/getPaidBills/';
export const GET_PAST_DUE_BILLS = '/bill/getPastDueBills/';
export const GET_DUE_BILLS = '/bill/getDueBills/';
export const BILL_UPLOAD = '/bill/upload/';
export const GENERATE_OTP = '/user/generateOTP/';
export const VALIDATE_OTP = '/user/validateOTP/';
